export default __webpack_public_path__ + "static/media/arrow.45f09e04.png";